import { lazy } from '@/service/lazy'

export default [{
  name: 'Leads',
  path: 'gerenciar-leads',
  id: 'gerenciar_leads',
  icon: 'fa fa-filter',
  component: lazy('app/default/relatorios/gerenciarleads/index'),
  meta: { requireAuth: true, rules: ['gerenciar_leads'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/gerenciarleads.js